import _mapKeys from 'lodash/mapKeys';
import queryString from 'query-string';

import { AttributionData } from '../interfaces';

export function mapAttribution(attribution: AttributionData, tracker?: string) {
  return {
    adj_t: tracker,
    adj_campaign: (attribution.source || attribution.c || attribution.c_id) ? `${attribution.source ? (attribution.source + ' ||| ') : ''}${attribution.c} (${attribution.c_id})` : undefined,
    adj_adgroup: (attribution.adset || attribution.adset_id) ? `${attribution.adset} (${attribution.adset_id})` : undefined,
    adj_creative: (attribution.ad || attribution.ad_id) ? `${attribution.ad} (${attribution.ad_id})` : undefined,
  };
}

export function trackImpression(attribution: AttributionData, tracker: string) {
  fetch(queryString.stringifyUrl({
    url: `https://view.adjust.com/impression/${tracker}`,
    query: {
      ..._mapKeys(mapAttribution({
        ...attribution,
        c: attribution.c ? attribution.c + ' | impression' : attribution.c,
      }), (v, k) => k.replace(/^adj_/, '')),
    },
  }), {
    mode: 'no-cors',
  })
    .catch(ex => {
      throw Error('Failed to track Adjust impression', { cause: ex });
    });
}
